module.exports = __webpack_public_path__ + "static/media/Credits-25.92c4e574.pdf";